import { Link } from "gatsby";
import * as React from "react";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

// import { useEffect, useState } from "react";
// import { useInView } from "react-intersection-observer";
import { Post } from "../../../../contexts/blog/domain/post";
import { getSlugWithLang } from "../../../../modules/Shared/Utils/getSlugWithLang";

export const Hero = (props: { post: Post }) => {
  // const { title; categories: Category[]; authors: Author[] } = props.heropost;
  const { i18n } = useTranslation("global");
  const { post } = props;

  // const { ref, inView } = useInView({
  //   threshold: 1,
  // });
  // const [animate, setAnimate] = useState(false);
  // useEffect(() => {
  //   if (inView) {
  //     setAnimate(false);
  //   } else {
  //     setAnimate(true);
  //   }
  // }, [ref, inView]);

  const categories_render: ReactNode[] = [];

  post.categories.forEach((category, index) =>
    categories_render.push(
      <span key={index}>
        <Link
          to={getSlugWithLang(`/thebakery/${category.slug}/`, i18n.language)}
          title={`Ver todos los posts de ${category.title}`}
          className="a-category"
        >
          {category.title}
        </Link>
        <br />
      </span>,
    ),
  );

  const authors_render: ReactNode[] = [];

  post.authors.forEach((author, index) =>
    authors_render.push(
      <p key={index} className="h2 a-author">
        {author.name}
      </p>,
    ),
  );

  return (
    <div className="o-hero">
      {/*<div className="background">*/}
      {/*  <div></div>*/}
      {/*</div>*/}
      <div className="container">
        <div className="m-info grid-40-60 grid-40-60--break-pro grid-40-60--no-gap">
          <div className="m-categories">
            {categories_render}
            <span className="line-device" />
          </div>
          <div>
            <h1 className="a-title">{post.title}</h1>
            {authors_render}
          </div>
        </div>
      </div>
    </div>
  );
};
